<template>
  <v-container class="pa-0" v-if="!isLoading && organizationPlan.id">
    <div class="py-4 pl-4">
      <v-btn text ref="button-toolbar-close" @click="$emit('close')">
        <v-icon>close</v-icon>
        <span>{{ $t('general.close') }}</span>
      </v-btn>
    </div>
    <v-row class="px-4">
      <v-col cols="12">
        <v-card class="rounded-lg pa-4" flat>
          <v-row>
            <v-col cols="12" md="6">
              <v-card-title class="d-flex align-center">
                <span class="d-flex align-center justfiy-evenly">
                  {{ $t('organization_billing.title') }}</span
                >
              </v-card-title>
              <v-card-text>
                <div>
                  <p class="body-2" style="color: #2661FF">
                    {{ $t('organization_billing.description') }}
                  </p>
                </div>
              </v-card-text>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="d-flex flex-column justify-center align-center"
            >
              <template>
                <v-dialog
                  v-model="dialog"
                  scrollable
                  max-width="400px"
                  left="0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex justify-end align-center pr-4">
                      <v-btn
                        class="text-uppercase"
                        color="#2661FF"
                        min-width="100px"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon style="color: #fff;" class="pr-2"
                          >query_stats</v-icon
                        >
                        <span style="color: #fff;">
                          {{ $t('organization_billing.calculate_month') }}
                        </span>
                      </v-btn>
                    </div>
                  </template>
                  <v-card class="rounded-lg" flat>
                    <v-card-title
                      class="body-1 d-flex justify-center mb-2 mt-1 font-weight-regular"
                      >{{
                        $t('organization_billing.select_month')
                      }}</v-card-title
                    >
                    <v-divider class="mb-4"></v-divider>
                    <v-card-text class="d-flex flex-column justify-center mb-2">
                      <v-date-picker
                        v-model="billing_date"
                        type="month"
                        :max="monthLimit"
                        color="#2661FF"
                      ></v-date-picker>

                      <v-btn
                        color="#2661FF"
                        min-width="100px"
                        @click="calculateBilling"
                        :disabled="isLoadingCalculateBilling"
                        :loading="isLoadingCalculateBilling"
                      >
                        <span style="color: #fff;">
                          {{ $t('actions.calculate') }}
                        </span>
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </template>
              <div class="pt-2">
                <v-btn
                  outlined
                  min-width="100px"
                  color="#2661FF"
                  class="text-uppercase"
                  @click.stop="openManualBilling = !openManualBilling"
                >
                  <v-icon class="pr-2">
                    edit
                  </v-icon>
                  <span style="color: #2661FF;">
                    {{ $t('organization_billing.manual_billing.title') }}
                  </span>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <!-- PLAN RESUME -->
          <v-card-text>
            <v-row no-gutters v-if="organizationPlan.plan_id && planDetail">
              <v-col cols="12">
                <v-card
                  color="#EBF0FF"
                  outlined
                  class="rounded-lg"
                  style="border-left: 8px solid #2661ff !important;"
                >
                  <v-card-title
                    class="subtitle-1 font-weight-medium"
                    style="color: #2661FF;"
                  >
                    <v-icon color="#2661FF" class="px-4 mb-1">
                      warning
                    </v-icon>
                    <span>{{
                      $t('organization_billing.plan_resume.title')
                    }}</span>
                  </v-card-title>
                  <v-card-text style="font-size: 14px;">
                    <template>
                      <v-container>
                        <v-row no-gutters>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                          >
                            <p
                              class="body-1 text-center font-weight-light"
                              style="color: #2661FF; opacity: 80%;"
                            >
                              {{ $t('organization_billing.plan_resume.name') }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                          >
                            <p class="body-1 text-center">
                              {{ planDetail.display_name }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                          >
                            <p
                              class="body-1 text-center font-weight-light"
                              style="color: #2661FF; opacity: 80%;"
                            >
                              {{
                                $t('organization_billing.plan_resume.currency')
                              }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                          >
                            <p class="body-1 text-center">
                              {{
                                `${planDetail.currency.name} (${planDetail.currency.code})`
                              }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                            v-if="organizationPlan.amount"
                          >
                            <p
                              class="body-1 text-center font-weight-light"
                              style="color: #2661FF; opacity: 80%;"
                            >
                              {{
                                $t('organization_billing.plan_resume.amount')
                              }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                            v-if="organizationPlan.amount"
                          >
                            <p class="body-1 text-center">
                              {{
                                `${organizationPlan.currency.symbol} ${organizationPlan.amount}
                              (${organizationPlan.currency.code})`
                              }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                            v-if="planDetail.fee_percentage"
                          >
                            <p
                              class="body-1 text-center font-weight-light"
                              style="color: #2661FF; opacity: 80%;"
                            >
                              {{
                                $t(
                                  'organization_billing.plan_resume.percentage'
                                )
                              }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                            v-if="planDetail.fee_percentage"
                          >
                            <p class="body-1 text-center">
                              {{
                                planDetail.fee_percentage
                                  ? `${planDetail.fee_percentage}%`
                                  : 0
                              }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-card-title
                      class="subtitle-1 font-weight-medium px-14"
                      style="color: #2661FF;"
                    >
                      <span>
                        {{ $t('organization_billing.automation_resume.title') }}
                      </span>
                    </v-card-title>
                    <v-card-text
                      v-for="service in organizationPlan.billingServices"
                      :key="service.id"
                      style="font-size: 14px;"
                    >
                      <v-container>
                        <v-row no-gutters>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                          >
                            <p
                              class="body-1 text-center font-weight-light"
                              style="color: #2661FF; opacity: 80%;"
                            >
                              {{
                                $t(
                                  'organization_billing.automation_resume.name'
                                )
                              }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                          >
                            <p class="body-1 text-center">
                              {{
                                service.display_name
                                  ? service.display_name
                                  : service.name
                                  ? service.name
                                  : '-'
                              }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                          >
                            <p
                              class="body-1 text-center font-weight-light"
                              style="color: #2661FF; opacity: 80%;"
                            >
                              {{
                                $t(
                                  'organization_billing.automation_resume.email_cost'
                                )
                              }}
                            </p>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            class="d-flex justify-center align-center"
                          >
                            <p class="body-1 text-center">
                              {{
                                `${organizationPlan.currency.symbol} ${service.cost}`
                              }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-navigation-drawer
      v-if="organizationPlan && organizationPlan.id"
      :value="openManualBilling"
      @input="inputManualBilling"
      :width="'90%'"
      temporary
      fixed
      right
      color="grey lighten-3"
      style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1); padding-top: 65px;"
    >
      <ManualBilling
        :organization_id="organization.id"
        @close="closeManualBilling"
      />
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ManualBilling from '@/components/Billing/ManualBilling.vue'

export default {
  components: {
    ManualBilling
  },
  data() {
    return {
      isLoading: false,
      isLoadingCalculateBilling: false,
      dialog: false,
      openManualBilling: false,
      planDetail: null,
      billing_date: this.$moment()
        .startOf('month')
        .format('YYYY-MM'),
      monthLimit: this.$moment()
        .endOf('month')
        .format('YYYY-MM'),
      startDate: '',
      endDate: ''
    }
  },
  async created() {
    try {
      this.isLoading = true
      await this.getPlans()
      this.setPlanDetail()
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },
  watch: {
    organizationPlan() {
      this.setPlanDetail()
    }
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      organizationPlan: ({ organization: { organizationPlan } }) =>
        organizationPlan,
      organizationCurrencyCode: ({ organization: { organization } }) =>
        organization.currency,
      currencies: ({ countries: { currencies } }) => currencies,
      plans: ({ plans: { plans } }) => plans
    })
  },
  methods: {
    ...mapActions({
      getPlans: 'plans/getPlans',
      calculateMonthlyBilling: 'billings/calculateBilling'
    }),
    ...mapMutations({
      setUpdateRequired: 'organization/setUpdateRequired'
    }),
    setPlanDetail() {
      this.planDetail = this.plans.find(
        plan => plan.id === this.organizationPlan.plan_id
      )
    },
    async calculateBilling() {
      const { id: organization_id } = this.organization
      if (this.billing_date) {
        const billing_date = this.$moment(this.billing_date)
          .startOf('month')
          .utc()
          .format()

        this.isLoadingCalculateBilling = true
        // TODO: MAKE THIS A LISTENER LIKE DOWNLOADS
        await this.calculateMonthlyBilling({
          organization_id,
          billing_date,
          is_global: false
        })

        this.isLoadingCalculateBilling = false
        this.dialog = false
        this.setUpdateRequired(true)
      } else {
        this.dialog = false
      }
    },
    closeManualBilling() {
      this.openManualBilling = false
    },
    inputManualBilling(arg) {
      if (!arg) {
        this.openManualBilling = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
